module.exports = __webpack_public_path__ + "img/user.32c0a44c.svg";